import dayjs from 'dayjs'

export const dayjsWithTz = (date?: dayjs.ConfigType) => {
  return dayjs(date).tz()
}

const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

export const isBranchTimezoneDifferent = (branchTimezone: string) => {
  return getBrowserTimezone() !== branchTimezone
}
